module.exports = __webpack_public_path__ + "img/bank-account.095c5e34.svg";